import Swiper from 'swiper';
import { Navigation, A11y, Keyboard } from 'swiper/modules';

// Blueprint: Produkt-Hotspots (Hotspot-Bild-Slider)
// 1:1 aus Figma (node 420:815): zentrierter Slider (1081px-Slide, Seiten-Peek
// abgedunkelt/geblurt/skaliert), Pfeile darunter. Pro Slide bis zu 3 Hotspots
// (CMS-Felder "x;y;Titel", Koordinaten in % der Bildflaeche). Klick auf einen
// Hotspot oeffnet das Detail-Modal (Figma Frame 185: Bild, Logo, Titel, Text,
// "Download Datenblatt") als natives <dialog> im Top-Layer; der Hotspot-Dot
// wird waehrenddessen pink (Figma Frame 172). Swiper 11, Vanilla.

export function initProductHotspots() {
    document.querySelectorAll('.js-productHotspots').forEach((root) => {
        const container = root.querySelector('.js-productHotspotsSwiper');
        if (!container) return;

        // Loop mit centeredSlides braucht auf Desktop ~2 Slides pro Seite
        // (sichtbar sind ~1.3) — bei nur 2-3 gepflegten Slides fehlt dafuer
        // Material und der rechte Peek bleibt beim Init leer. Slides einmal
        // klonen (vor der Hotspot-Verdrahtung, damit Klone Listener bekommen).
        const wrapper = container.querySelector('.swiper-wrapper');
        const originalSlides = wrapper ? Array.from(wrapper.querySelectorAll('.productHotspots__slide')) : [];
        if (originalSlides.length >= 2 && originalSlides.length <= 3) {
            originalSlides.forEach((slide) => wrapper.appendChild(slide.cloneNode(true)));
        }

        // ── Hotspots positionieren + Modal verdrahten ────────────────────────────
        root.querySelectorAll('.js-productHotspotsHotspot').forEach((btn) => {
            // Position "x;y" (Feld hotspotN), Titel aus hotspotNTitle.
            // Altformat "x;y;Titel" in einem Feld wird weiter unterstuetzt.
            const parts = (btn.dataset.hotspot || '').split(';');
            const x = parseFloat(parts.shift());
            const y = parseFloat(parts.shift());
            const label = (btn.dataset.hotspotTitle || parts.join(';')).trim();
            if (Number.isNaN(x) || Number.isNaN(y) || !label) {
                btn.remove();
                return;
            }
            btn.style.left = `${x}%`;
            btn.style.top = `${y}%`;
            btn.setAttribute('aria-label', label);

            const slide = btn.closest('.productHotspots__slide');
            const dialog = slide
                ? slide.querySelector(`.js-productHotspotsModal[data-hotspot-index="${btn.dataset.hotspotIndex}"]`)
                : null;
            if (!dialog) return; // kein Detail gepflegt -> Hotspot rein dekorativ

            // Modal-Titel = Hotspot-Label (CMS pflegt beides in einem Feld)
            const title = dialog.querySelector('.js-productHotspotsModalTitle');
            if (title) title.textContent = label;

            // showModal() fokussiert sonst das erste fokussierbare Element
            // ("Download Datenblatt") und zeigt es dauerhaft markiert an.
            dialog.tabIndex = -1;

            btn.addEventListener('click', () => {
                dialog.showModal();
                dialog.focus({ preventScroll: true });
                btn.classList.add('is-open');
            });

            // Esc/close() -> Dot zuruecksetzen
            dialog.addEventListener('close', () => btn.classList.remove('is-open'));

            // Klick auf den Backdrop schliesst (Klick-Target ist dann der Dialog selbst)
            dialog.addEventListener('click', (event) => {
                if (event.target === dialog) dialog.close();
            });

            const closeBtn = dialog.querySelector('.js-productHotspotsModalClose');
            if (closeBtn) closeBtn.addEventListener('click', () => dialog.close());
        });

        const slideCount = root.querySelectorAll('.productHotspots__slide').length;

        // Peeks links/rechts sind ab dem ersten Frame sichtbar -> lazy wuerde
        // erst beim Reinrotieren laden und kurz leer flackern.
        root.querySelectorAll('.productHotspots__slide img[loading="lazy"]').forEach((img) => {
            img.loading = 'eager';
        });

        const swiper = new Swiper(container, {
            modules: [Navigation, A11y, Keyboard],
            slidesPerView: 'auto',
            centeredSlides: true,       // Figma: aktiver Slide mittig, Peek links/rechts
            spaceBetween: 40,           // Figma: Luecke zum Peek
            loop: slideCount >= 4,
            loopAdditionalSlides: 1,
            rewind: slideCount < 4,
            grabCursor: true,
            watchOverflow: true,
            keyboard: { enabled: true },
            a11y: { enabled: true },
            navigation: {
                prevEl: root.querySelector('.js-productHotspotsPrev'),
                nextEl: root.querySelector('.js-productHotspotsNext'),
            },
            breakpoints: {
                768: { spaceBetween: 40 },
                0:   { spaceBetween: 16 },
            },
        });

        // Swiper 11 sortiert bei loop + centeredSlides + wenigen Slides den
        // "next"-Slide beim Init nicht nach rechts -> rechter Peek fehlt bis
        // zur ersten Interaktion. loopFix() erzwingt das Arrangement.
        if (swiper.params.loop) {
            swiper.loopFix();
        }
    });
}
